import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';
import { DatePicker } from 'antd';
import moment from 'moment';

export default class AddPayment extends Component {
	render() {
		return (
			<div className="add-payment-form">
				<h4 className="form-header">Payment Form</h4>
				<Col className="form-elements" md={12}>
					<Col className="form-element" md={4}>
						<label className="control-label is-imp">Transaction Id: </label>
						<input type="text" className="form-control" id="txn_id" name="txn_id" value={this.props.newPayment.txn_id}
						  placeholder="Transaction Id" onChange={this.props.handleChange.bind(this, 'txn_id')} required />
						<span hidden={!this.props.showTxnError}><span className="required-span">Please enter a valid Transaction Id.</span></span>
					</Col>

					<Col className="form-element" md={4}>
						<label className={this.props.website_id === null ? "control-label" : "control-label is-imp"}>Invoice Id: </label>
						<input type="text" className="form-control" id="invoice_id" name="invoice_id" value={this.props.newPayment.invoice_id}
						  placeholder="Invoice Id" onChange={this.props.handleChange.bind(this, 'invoice_id')} required />
						<span hidden={!this.props.showInvoiceError}><span className="required-span">Please enter a valid Invoice Id.</span></span>
					</Col>

					{this.props.hasOwnProperty('type') && this.props.type === 'edit' && this.props.newPayment.invoice_url !== undefined && this.props.newPayment.invoice_url !== '' ? (
						<Col className="form-element" md={4}>
							<label className={this.props.website_id === null ? "control-label" : "control-label is-imp"}>
								<span>{'Invoice File: '}<a className="le-link underline" href={this.props.newPayment.invoice_url} target="_blank">Url</a></span>
							</label>
							<input type="file" className="form-control" id="invoice" name="invoice"
							  onChange={this.props.handleChange.bind(this, 'invoice')} required />
							<span hidden={!this.props.showInvoiceUrlError}><span className="required-span">Please upload a valid Invoice.</span></span>
						</Col>
					) : (
						<Col className="form-element" md={4}>
							<label className={this.props.website_id === null ? "control-label" : "control-label is-imp"}>Invoice File: </label>
							<input type="file" className="form-control" id="invoice" name="invoice"
							  onChange={this.props.handleChange.bind(this, 'invoice')} required />
							<span hidden={!this.props.showInvoiceUrlError}><span className="required-span">Please upload a valid Invoice.</span></span>
						</Col>
					)}

					<Col className="form-element" md={4}>
						<label className="control-label is-imp">Payment Date: </label>
						<DatePicker id="payment_date" value={this.props.newPayment.payment_date} format='DD-MM-YYYY'
						  placeholder="Payment Date" onChange={this.props.handleChange.bind(this, 'payment_date')} />
						<span hidden={!this.props.showDateError}><span className="required-span">Please enter a valid Payment Date.</span></span>
					</Col>

					<Col className="form-element" md={4}>
						<label className="control-label is-imp">Transaction Amount: </label>
						<input type="text" className="form-control" id="amount" name="amount" value={this.props.newPayment.amount}
						  placeholder="Transaction Amount" onChange={this.props.handleChange.bind(this, 'amount')} required />
						<span hidden={!this.props.showAmountError}><span className="required-span">Please enter a valid Transaction Amount.</span></span>
					</Col>

					<Col className="form-element" md={4}>
						<label className="control-label">Offer: </label>
						<input type="text" className="form-control" id="offer" name="offer" value={this.props.newPayment.offer}
						  placeholder="Offer" onChange={this.props.handleChange.bind(this, 'offer')} required />
					</Col>

					<Col className="form-element" md={4}>
						<label className="control-label is-imp">Is Renewal: </label>
						<select className="form-control" id="is_renewal" name="is_renewal" value={this.props.newPayment.is_renewal}
						  placeholder="Is Renewal" onChange={this.props.handleChange.bind(this, 'is_renewal')} required>
						  <option value={true}>Yes</option>
						  <option value={false}>No</option>
						</select>
						<span hidden={!this.props.showRenewalError}><span className="required-span">Please select a valid choice.</span></span>
					</Col>

					<Col className="form-element" md={4}>
						<label className="control-label is-imp">Payment Period: </label>
						<select className="form-control" id="paid_for" name="paid_for" value={this.props.newPayment.paid_for}
						  placeholder="Payment Period" onChange={this.props.handleChange.bind(this, 'paid_for')} required>
						  <option value='' disabled>Select Payment Period</option>
						  <option value='1 Month'>1 Month</option>
						  <option value='6 Months'>6 Months</option>
						  <option value='1 Year'>1 Year</option>
						  <option value='2 Years'>2 Years</option>
						  <option value='3 Years'>3 Years</option>
						  <option value='5 Years'>5 Years</option>
						  <option value='Trial'>Trial</option>
						  <option value='Partial'>Partial</option>
						</select>
						<span hidden={!this.props.showPeriodError}><span className="required-span">Please select a valid Payment Period.</span></span>
					</Col>

					<Col className="form-element" md={4}>
						<label className="control-label is-imp">Mode Of Payment: </label>
						<select className="form-control" id="mode" name="mode" value={this.props.newPayment.mode}
						  placeholder="Mode Of Payment" onChange={this.props.handleChange.bind(this, 'mode')} required>
						  <option value='' disabled>Select Mode Of Payment</option>
						  <option value='Cash'>Cash</option>
						  <option value='Cheque'>Cheque</option>
						  <option value='NEFT'>NEFT</option>
						  <option value='Wallet-UPI'>Wallet/UPI</option>
						  <option value='PG'>Payment Gateway</option>
						  <option value='DD'>Demand Draft</option>
						</select>
						<span hidden={!this.props.showModeError}><span className="required-span">Please select a valid Mode Of Payment.</span></span>
					</Col>

					<Col className="form-element" md={4}>
						<label className="control-label is-imp">POC: </label>
						<input type="text" className="form-control" id="poc" name="poc" value={this.props.newPayment.extras.poc}
						  placeholder="POC" onChange={this.props.handleChange.bind(this, 'poc')} required />
						<span hidden={!this.props.showPOCError}><span className="required-span">Please enter a valid POC.</span></span>
					</Col>
				</Col>

				<Col md={3} className="form-buttons-container">
					<button className="btn form-save-button" onClick={this.props.addNewPayment} disabled={this.props.addPaymentLoader}>
						{this.props.addPaymentLoader ? (
							<span>Saving <i className="fa fa-spinner fa-spin"></i></span>
						) : ('Save')}
					</button>
					<button className="btn form-cancel-button" onClick={this.props.resetAddPaymentForm}>Cancel</button>
				</Col>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/ManagePayments/AddPayment.js